import * as React from 'react';

import FolderPersonal16 from './FolderPersonal16';

export const folderPersonal16 = () => <FolderPersonal16 />;

export default {
    title: 'Icon|Fill|FolderPersonal16',
    component: FolderPersonal16,
    parameters: {
        notes: "`import FolderPersonal16 from 'box-ui-elements/es/icon/fill/FolderPersonal16';`",
    },
};
